import classNames from 'classnames';
import View from '../View';
import styles from './VisualDistribution.module.scss';

/**
 * VisualDistribution
 *
 * @return {JSX.Element}
 */
const VisualDistribution = ({
  className,
  green,
  flex,
  value = 0,
  vertical,
}) => {
  return (
    <View
      className={classNames(
        styles.VisualDistribution,
        green && styles.VisualDistribution__green,
        vertical && styles.VisualDistribution__vertical,
        flex && styles.VisualDistribution__flex,
        className,
        `${VisualDistribution.displayName}`
      )}
    >
      <View className={styles.Value} style={{ flex: `0 0 ${value * 100}%` }} />
    </View>
  );
};

VisualDistribution.displayName = 'VisualDistribution';

export default VisualDistribution;
